import { environment } from './../environments/environment.prod';
// import { environment } from './../environments/environment';

export class AppApiInterface{
   static  IMALI_API=environment.imali_api
   static  IMALI_API_AUTH= environment.imali_api_auth
}
